import { useAuth } from "../Redux/Auth/Auth";
import Login from "./Login";
import React from "react";
import Home from "./Home";
import { AUTHENTICATED, UNAUTHENTICATED } from "../Redux/Auth/Types";

export default () => {
  const auth = useAuth();
  switch (auth.type) {
    case AUTHENTICATED:
      return <Home />;
    case UNAUTHENTICATED:
      return <Login />;
  }
};
